import React, { Component } from "react";
import axios from "axios";
import { routes } from "../General";
import moment from "moment";
import Alerts from "../../util/Alerts";
import { formatMoney } from "../../coms/siniestros/Deducibles";

export class ContratanteGEN extends Component {
    constructor(props) {
        super(...arguments);
        this.state = {};
        this.alert = React.createRef();
    }

    imprimir = pdf => {
        axios
            .get(routes.api + "/siniestros-vam/imprimir", {
                params: {
                    cdIncSiniestro: this.props.siniestro.cdIncSiniestro
                        ? this.props.siniestro.cdIncSiniestro
                        : this.props.siniestro.numSiniestro,
                    cdReclamo: this.props.siniestro.cdReclamo,
                    cdCompania: this.props.siniestro.cdCompania,
                    vam: false,
                    pdf: pdf,
                },
                responseType: "arraybuffer",
            })
            .then(response => {
                let blob = new Blob([response.data], {
                    type: pdf ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                let url = window.URL.createObjectURL(blob);
                window.open(url);
                this.alert.current.show_info("Generado con éxito");
            })
            .catch(error => {
                this.alert.current.handle_error(error);
            });
    };

    render() {
        let { siniestro, cliente, diasExtra } = this.props;
        let dias2 = siniestro.dias2 ? siniestro.dias2 : 0;
        let dias = siniestro.dias ? siniestro.dias : 0;
        let dias3 = (diasExtra || {}).dias;
        let fechaEstimada = (diasExtra || {}).fechaEstimada;
        let veh = siniestro.objeto.objCotizacion.vehiculo;

        return (
            <div className="col-lg-3 bg-primary pd-lateral pt-2 pt-md-5">
                <Alerts ref={this.alert} />
                <br />
                <table className="m-auto text-left fs12 line-height-normal">
                    <tbody>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Contratante:</td>
                        </tr>
                        <tr>
                            <td>{cliente.titular}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">No. Siniestro:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.numSiniestro}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Año:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.anoSiniestro}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Aseguradora:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.aseguradora.nmAseguradora}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Ramo:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.ramo.nmRamo}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Fc.Siniestro:</td>
                        </tr>
                        <tr>
                            <td>
                                {" "}
                                {siniestro.fcSiniestro
                                    ? moment(siniestro.fcSiniestro)
                                          .locale("moment/locale/es")
                                          .local()
                                          .format("DD/MMM/YYYY")
                                    : null}
                            </td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Des Objeto:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.objeto.dscObjeto}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Póliza:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.poliza}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Val Asegurado:</td>
                        </tr>
                        <tr>
                            <td>{formatMoney(siniestro.ramosCotizacion.valAsegurado)}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Causa:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.causa}</td>
                        </tr>
                        {veh && (
                            <tr>
                                <td className=" font-weight-bolder text-primary">Vehiculo:</td>
                            </tr>
                        )}
                        {veh && (
                            <tr>
                                <td>
                                    {`${veh.placa} ${veh.marca} ${veh.anioDeFabricacion} ${veh.color} ${veh.noDeMotor}
                            ${veh.modelo} ${veh.noDeChasis}`}
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td className=" font-weight-bolder text-primary">Estado:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.estadoActivo.estSiniestro.dscEstado}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">Fc Estado:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.estadoActivo.fcSeguimiento}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">No. Repor Aseg:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.numRepAseg}</td>
                        </tr>
                        <tr>
                            <td className=" font-weight-bolder text-primary">No. Sinies Aseg:</td>
                        </tr>
                        <tr>
                            <td>{siniestro.numAseguradora}</td>
                        </tr>
                        <tr>
                            <td> {siniestro.tpSiniestro}</td>
                        </tr>
                        <br />
                    </tbody>
                </table>
            </div>
        );
    }
}
